export enum KioskPreferencesQuestionsIds {
  CHECK_IN = 'checkIn',
  CHECK_OUT = 'checkOut',
}

export const UPDATE_FIXED_CACHE_KEY = 'UPDATE/SELF_SERVICE';
